import { Language } from './const';

const OVERRIDE_STORAGE_KEY = 'cosmos:i18n-lang-override';
const LANG_QUERY_PARAM = 'lang';

const LANGUAGE_ALIASES: Record<string, Language> = {
	en: Language.ENGLISH,
	'en-us': Language.ENGLISH,
	'zh-hk': Language.TRADITIONAL_CHINESE,
	'zh-cn': Language.SIMPLIFIED_CHINESE,
};

const isSupportedLanguage = (value: string): value is Language =>
	Object.values(Language).includes(value as Language);

const normalizeLanguage = (value: string): Language | null => {
	if (isSupportedLanguage(value)) {
		return value;
	}

	return LANGUAGE_ALIASES[value.toLowerCase()] ?? null;
};

export const getQueryLanguageOverride = (): Language | null => {
	if (typeof window === 'undefined') {
		return null;
	}

	const fromUrl = new URLSearchParams(window.location.search).get(
		LANG_QUERY_PARAM
	);
	if (fromUrl) {
		const lang = normalizeLanguage(fromUrl);
		if (lang) {
			sessionStorage.setItem(OVERRIDE_STORAGE_KEY, lang);
			return lang;
		}
	}

	const fromStorage = sessionStorage.getItem(OVERRIDE_STORAGE_KEY);
	if (fromStorage && isSupportedLanguage(fromStorage)) {
		return fromStorage;
	}

	return null;
};

export const hasActiveLanguageOverride = (): boolean =>
	getQueryLanguageOverride() !== null;

export const clearLanguageOverride = (): void => {
	sessionStorage.removeItem(OVERRIDE_STORAGE_KEY);
};
